module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/home/components/home-main-modal-drag/home-main-modal-drag.component.sass
// module id = ./src/app/modules/home/components/home-main-modal-drag/home-main-modal-drag.component.sass
// module chunks = main